export function operacaoRadAdmDadosFaturamentoUnidataInRequest(params = {}) {
  return {
    type: '@operacaoradadmdadosfaturamentounidata/OPERACAORADADMDADOSFATURAMENTOUNIDATA_IN_REQUEST',
    payload: { params },
  };
}

export function findOperacaoRadAdmDadosFaturamentoUnidata(fatu_codigo) {
  return {
    type: '@operacaoradadmdadosfaturamentounidata/FIND_OPERACAORADADMDADOSFATURAMENTOUNIDATA',
    payload: { fatu_codigo },
  };
}

export function failedRequest() {
  return {
    type: '@operacaoradadmdadosfaturamentounidata/FAILED_REQUEST',
  };
}

export function deleteOperacaoRadAdmDadosFaturamentoUnidata(fatu_codigo, params) {
  return {
    type: '@operacaoradadmdadosfaturamentounidata/DELETE_OPERACAORADADMDADOSFATURAMENTOUNIDATA',
    payload: { fatu_codigo, params },
  };
}

export function updateOperacaoRadAdmDadosFaturamentoUnidata(operacaoradadmdadosfaturamentounidata, params) {
  return {
    type: '@operacaoradadmdadosfaturamentounidata/UPDATE_OPERACAORADADMDADOSFATURAMENTOUNIDATA',
    payload: { operacaoradadmdadosfaturamentounidata, params },
  };
}

export function storeOperacaoRadAdmDadosFaturamentoUnidata(operacaoradadmdadosfaturamentounidata, params) {
  return {
    type: '@operacaoradadmdadosfaturamentounidata/STORE_OPERACAORADADMDADOSFATURAMENTOUNIDATA',
    payload: { operacaoradadmdadosfaturamentounidata, params },
  };
}

export function successInRequest(
  operacaoradadmdadosfaturamentounidata,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@operacaoradadmdadosfaturamentounidata/SUCCESS_IN_REQUEST',
    payload: { operacaoradadmdadosfaturamentounidata, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(operacaoradadmdadosfaturamentounidata) {
  return {
    type: '@operacaoradadmdadosfaturamentounidata/SUCCESS_REQUEST',
    payload: { operacaoradadmdadosfaturamentounidata },
  };
}

export function successRemove(params) {
  return {
    type: '@operacaoradadmdadosfaturamentounidata/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacaoradadmdadosfaturamentounidata/RECORD_FILTERING',
    payload: { params },
  };
}
